const handlePaymentOptionChange = (value,setPaymentOption) =>{
  setPaymentOption(value);
  // console.log(value);
}

export {handlePaymentOptionChange};